import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-field-any',
  templateUrl: './formly-field-any.component.html',
  styleUrls: ['./formly-field-any.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    IonicModule,
    CommonModule, 
    TranslateModule, 
  ],
})
export class FormlyFieldAnyComponent extends FieldType<FieldTypeConfig> {

  constructor() { 
    super();
  }

  // propagate onChange event to the caller
  public onChange(event: any) {
    if (this.field.props && this.field.props['onChange'] && this.field.props['onChange'].length > 0) {
      for (const callback of this.field.props['onChange']) {
        Promise.resolve(callback(this.field as any, event)).catch((error: any) => {
          console.error(`Error in onChange callback for field ${this.field?.key || 'unknown'}`, error);
        });
      }
    }
  }
}
